var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.updatingProjects === 'success' ? _c('div', {
    attrs: {
      "id": "table-ready"
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "#",
    attrs: {
      "id": "csv-export-link"
    },
    on: {
      "click": _vm.fetchProjectCsv
    }
  }, [_c('b-img', {
    attrs: {
      "src": _vm.raftHelper.getCsvIconPath(),
      "width": "24",
      "height": "24",
      "fluid": "",
      "alt": "CSV Download"
    }
  })], 1), _vm._v(" "), _c('b-form', [_c('fieldset', {
    staticClass: "biological-project-listing-filters"
  }, [_c('legend', [_vm._v("Project Filters")]), _vm._v(" "), _c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('short-text-filter', {
    attrs: {
      "id": "project-title",
      "label": "Title",
      "get-value": _vm.projectTitle,
      "update-method": _vm.updateFilter,
      "path": "projectTitle",
      "placeholder": "Project Title"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('short-text-filter', {
    attrs: {
      "id": "project-number",
      "label": "Project Number",
      "get-value": _vm.projectNumber,
      "update-method": _vm.updateFilter,
      "path": "projectNumber",
      "placeholder": "Project Number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('short-text-filter', {
    attrs: {
      "id": "approval-number",
      "label": "Approval Number",
      "get-value": _vm.approvalNumber,
      "update-method": _vm.updateFilter,
      "path": "approvalNumber",
      "placeholder": "Approval Number"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.bioSafetyLevels,
      "id": "bsl-sel",
      "label": "Biological Safety Level",
      "path": "selectedBsl",
      "current-set-value": _vm.selectedBsl,
      "multiple": true,
      "track-by": "value",
      "display-value": "label",
      "update-method": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.animalBioSafetyLevels,
      "id": "absl-sel",
      "label": "Animal Biological Safety Level",
      "path": "selectedAnimalBsl",
      "current-set-value": _vm.selectedAnimalBsl,
      "multiple": true,
      "track-by": "value",
      "display-value": "label",
      "update-method": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.largeScaleBioSafetyLevels,
      "id": "lsbsl-sel",
      "label": "Large Scale Biological Safety Level",
      "path": "selectedLargeBsl",
      "current-set-value": _vm.selectedLargeBsl,
      "multiple": true,
      "track-by": "value",
      "display-value": "label",
      "update-method": _vm.updateFilter
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.plantBioSafetyLevels,
      "id": "pbsl-sel",
      "label": "Plant Biosafety Level",
      "path": "selectedPlantBsl",
      "current-set-value": _vm.selectedPlantBsl,
      "multiple": true,
      "track-by": "value",
      "display-value": "label",
      "update-method": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.getAllLabs,
      "id": "group-fil",
      "multiple": true,
      "label": "Group",
      "zort_store-watch": "getSelectedGroups",
      "display-value": "title",
      "track-by": "nid",
      "path": "selectedGroups",
      "current-set-value": _vm.selectedGroups,
      "update-method": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('multi-select-filter', {
    attrs: {
      "get-value": _vm.statusOptions,
      "id": "status-fil",
      "multiple": false,
      "is-required": true,
      "label": "Status",
      "display-value": "title",
      "track-by": "key",
      "path": "selectedStatus",
      "current-set-value": _vm.selectedStatus,
      "update-method": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "raft-js-filter-cols"
  }, [_c('toggle-filter', {
    attrs: {
      "get-value": _vm.includeInactiveGroups,
      "id": "include-inactive-groups",
      "data-test": "include-inactive-groups",
      "label": "Include Inactive Groups",
      "update-method": _vm.updateFilter,
      "path": "includeInactiveGroups"
    }
  })], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('BaseTable', {
    ref: "table",
    attrs: {
      "items": _vm.bioProjects,
      "fields": _vm.fields,
      "total-items": _vm.totalItems,
      "current-page": _vm.currentPage,
      "is-busy": _vm.updatingProjects === 'busy',
      "class-prefix": "bio-projects",
      "no-local-sorting": true
    },
    on: {
      "update-current-page": _vm.updateCurrentPage,
      "sort-changed": _vm.sortingChanged
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "empty-text"
        }, [_vm._v("\n        There are currently no biological projects to list.\n      ")])];
      },
      proxy: true
    }, {
      key: "title",
      fn: function (row) {
        return [_c('a', {
          attrs: {
            "href": '/node/' + row.data.item.drupal_internal__nid
          }
        }, [_vm._v(_vm._s(row.data.item.title))])];
      }
    }, {
      key: "groups",
      fn: function (row) {
        return [_vm._l(row.data.item.og_audience, function (group, index) {
          return [index > 0 ? [_vm._v("  |  ")] : _vm._e(), _vm._v(" "), _c('a', {
            key: group.drupal_internal__nid,
            attrs: {
              "href": '/node/' + group.drupal_internal__nid
            }
          }, [_vm._v(_vm._s(group.title))])];
        })];
      }
    }])
  }), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right",
      "group": "alerts"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }